var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EDEDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.887 27.1667L25.4562 21.4703L25.2051 21.2327C23.3397 19.5887 20.9065 18.6957 18.3948 18.7333C15.8821 18.6986 13.4491 19.5942 11.5844 21.2403L11.3334 21.4703L12.9026 27.1667H23.887ZM18.3948 20.2667C20.3496 20.2386 22.2541 20.8724 23.785 22.0607L22.8121 25.6333H13.9775L13.0046 22.0607C14.5354 20.8724 16.44 20.2386 18.3948 20.2667ZM13.6872 12.6C13.6872 15.1405 15.7949 17.2 18.3948 17.2C20.9947 17.2 23.1024 15.1405 23.1024 12.6C23.1024 10.0595 20.9947 8 18.3948 8C15.7949 8 13.6872 10.0595 13.6872 12.6ZM21.5332 12.6C21.5332 14.2937 20.1281 15.6667 18.3948 15.6667C16.6615 15.6667 15.2564 14.2937 15.2564 12.6C15.2564 10.9063 16.6615 9.53333 18.3948 9.53333C20.1281 9.53333 21.5332 10.9063 21.5332 12.6Z",
    fill: "#00B956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.a36fac327b7503c94e8499bc637942ee.svg";
export { ForwardRef as ReactComponent };